import { Box, HStack, IconButton, useToast } from '@chakra-ui/react';
import { FiRotateCcw, FiPlay, FiPause, FiRotateCw } from 'react-icons/fi';
import IconWrapper from './IconWrapper';

interface VideoControlsProps {
  isPlaying: boolean;
  isLocked: boolean;
  onPlayPause: () => void;
  onSkip: (seconds: number) => void;
  showControls: boolean;
}

const VideoControls: React.FC<VideoControlsProps> = ({
  isPlaying,
  isLocked,
  onPlayPause,
  onSkip,
  showControls
}) => {
  const toast = useToast();

  const handleSkip = (seconds: number) => {
    if (isLocked) {
      toast({
        title: 'Player is locked',
        description: 'Unlock the player to skip.',
        status: 'warning',
        duration: 2000,
        isClosable: true,
      });
      return;
    }
    onSkip(seconds);
  };

  if (!showControls) return null;

  return (
    <Box
      position="absolute"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      zIndex={10}
    >
      <HStack gap={12} align="center" justify="center">
        <IconButton
          aria-label="Rewind 10 seconds"
          icon={<IconWrapper icon={FiRotateCcw} size={24} />}
          variant="ghost"
          colorScheme="white"
          size="lg"
          onClick={() => handleSkip(-10)}
          _hover={{ transform: 'scale(1.1)' }}
          transition="transform 0.2s"
        />

        <IconButton
          aria-label={isPlaying ? "Pause" : "Play"}
          icon={<IconWrapper icon={isPlaying ? FiPause : FiPlay} size={32} />}
          variant="ghost"
          colorScheme="white"
          size="xl"
          onClick={onPlayPause}
          _hover={{ transform: 'scale(1.1)' }}
          transition="transform 0.2s"
        />

        <IconButton
          aria-label="Forward 10 seconds"
          icon={<IconWrapper icon={FiRotateCw} size={24} />}
          variant="ghost"
          colorScheme="white"
          size="lg"
          onClick={() => handleSkip(10)}
          _hover={{ transform: 'scale(1.1)' }}
          transition="transform 0.2s"
        />
      </HStack>
    </Box>
  );
};

export default VideoControls;
